module.exports = __webpack_public_path__ + "img/yellow_bg.419c2fb7.png";